import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/services/query-keys';
import { fetchCampaignPayment } from './checkout-api';

export function useCampaignPayment(campaignId: string) {
  return useQuery({
    queryKey: queryKeys.campaigns.payment(campaignId),
    queryFn: () => fetchCampaignPayment(campaignId),
    enabled: !!campaignId,
  });
}
